// frontend/src/samkalp-faculty/FacultyDashboardHome.js
//
// Faculty dashboard landing page: quick stats across all of this faculty
// member's Live Sessions, plus shortcuts into Live Sessions and Teaching
// Copilot (both now live in this same workspace).
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { listMyLiveSessions } from '../api/liveSessionsApi';

const FacultyDashboardHome = ({ slug }) => {
    const navigate = useNavigate();
    const user = useSelector(state => state.user?.user);
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        listMyLiveSessions(slug)
            .then(setSessions)
            .catch(() => setSessions([]))
            .finally(() => setLoading(false));
    }, [slug]);

    const upcoming = sessions.filter(s => s.status === 'scheduled');
    const live = sessions.filter(s => s.status === 'live');
    const completed = sessions.filter(s => s.status === 'completed');

    const displayName = user?.display_name || user?.full_name
        || [user?.first_name, user?.last_name].filter(Boolean).join(' ') || 'there';

    return (
        <div>
            <h4 className="fw-bold mb-1">Welcome, {displayName}</h4>
            <p className="text-muted mb-4">Here's what's happening with your Samkalp classes.</p>

            {live.length > 0 && (
                <Card className="mb-4 border-danger">
                    <Card.Body className="d-flex justify-content-between align-items-center">
                        <div>
                            <Badge bg="danger" className="me-2">LIVE NOW</Badge>
                            <strong>{live[0].topic}</strong>
                        </div>
                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => navigate(`/samkalp-ias/faculty/live/${live[0].id}/host`)}
                        >
                            Open Broadcast Console
                        </button>
                    </Card.Body>
                </Card>
            )}

            <Row className="mb-4 g-3">
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <div className="text-muted small text-uppercase">Upcoming Sessions</div>
                            <div className="fs-2 fw-bold">{loading ? '—' : upcoming.length}</div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <div className="text-muted small text-uppercase">Completed Sessions</div>
                            <div className="fs-2 fw-bold">{loading ? '—' : completed.length}</div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <div className="text-muted small text-uppercase">Total Sessions Hosted</div>
                            <div className="fs-2 fw-bold">{loading ? '—' : sessions.length}</div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="g-3">
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <h6 className="fw-bold">Live Sessions</h6>
                            <p className="text-muted small">Schedule a new class, manage upcoming sessions, review Q&amp;A and feedback from past ones.</p>
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => navigate('/samkalp-ias/faculty/live-sessions')}>
                                Go to Live Sessions
                            </button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <h6 className="fw-bold">Teaching Copilot</h6>
                            <p className="text-muted small">Lesson plans, quizzes, teaching materials, and student analytics for your assigned subjects.</p>
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => navigate(`/samkalp-ias/faculty/copilot/${slug}`)}>
                                Open Teaching Copilot
                            </button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default FacultyDashboardHome;
